<template>
  <div>
    <div class="row">
      <!-- phpmyadmin card -->
      <div class="col-md-6 mb-4">
        <PhpMyAdmin :url="phpMyAdminUrl" :status="phpMyAdminStatus" />
      </div>

      <!-- quick add database and user card -->
      <div class="col-md-6 mb-4">
        <DbAddWithUser :site="site" :site-status="siteStatus" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 mb-4">
        <DbsTable :databases="databases" :site="site" :site-status="siteStatus" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 mb-4">
        <DbUsersTable :users="users" :site="site" :site-status="siteStatus" />
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import DbAddWithUser from "@/components/smart/cards/DbAddWithUser";
import DbsTable from "@/components/smart/tables/DbsTable";
import DbUsersTable from "@/components/smart/tables/DbUsersTable";
import PhpMyAdmin from "@/components/smart/cards/PhpMyAdmin";
import store from "@/store";

export default {
  name: "PlanDbPage",
  components: { PhpMyAdmin, DbAddWithUser, DbsTable, DbUsersTable },
  setup() {
    // site
    const site = computed(() => store.getters["plans/getPrimarySite"]);
    const siteStatus = computed(() => store.getters["plans/getPrimarySiteStatus"]);

    // databases
    const databases = computed(() => ({
      list: store.getters["databases/getList"],
      status: store.getters["databases/getStatus"],
    }));

    // database users
    const users = computed(() => ({
      list: store.getters["databaseUsers/getList"],
      status: store.getters["databaseUsers/getStatus"],
    }));

    // phpmyadmin
    const phpMyAdminUrl = computed(() => store.getters["sites/getPhpMyAdminUrl"]);
    const phpMyAdminStatus = computed(() => store.getters["sites/getPhpMyAdminUrlStatus"]);

    onMounted(() => {
      store.dispatch("sites/getPhpMyAdminUrl", site.value.id);
      store.dispatch("databases/getList", { siteId: site.value.id });
      store.dispatch("databaseUsers/getList", { siteId: site.value.id });
    });
    return {
      site,
      siteStatus,
      databases,
      users,
      phpMyAdminStatus,
      phpMyAdminUrl,
    };
  },
};
</script>
